import React from 'react';
import cn from 'classnames';
import { Check, X } from 'react-feather';
import QuestionDetails from 'components/shared/QuestionDetails';
import VideoResponse from 'components/VideoResponse/Grading/VideoResponse';
import ConditionalList from 'components/shared/ConditionalList';
import CriteriaList from 'components/VideoResponse/Grading/CriteriaList';
import ChatDetails from './Chat/ChatDetails';

const correctnessIconFragment = answer => {
  const icon = answer.answer.correct ? (
    <Check
      strokeWidth="5"
      size="12"
      viewBox="0 0 24 24"
      className="c-success as-fs mt-4 mr-4 minw-16"
    />
  ) : (
    <X
      strokeWidth="5"
      size="12"
      viewBox="0 0 24 24"
      className="c-danger-red as-fs mt-4 mr-4 minw-16"
    />
  );
  return answer.answerIsCorrectOrIncorrect ? (
    icon
  ) : (
    <div className="w-20">&nbsp;</div>
  );
};

const ReportCardMobileView = ({
  hasGraderFeedback,
  canViewRecordingLink,
  api,
  currentUserId,
  ratings,
  userName,
  progressUserId,
  answers,
}) => {
  const RenderMobileRows = () => {
    return answers.map(answer => {
      const data = {
        id: answer.id,
        criteriaRatings: answer.criteriaRatings,
        ratingOptions: ratings,
        preview: true,
        i18n: {
          no_description: t('feedback_criteria.criterion.no_description'),
        },
      };
      const initialStateVideoResponse = {
        data: {
          questionAutomatedAnalysis: answer.answer.question_automated_analysis,
          questionAutomatedAnalysisKeywordMatchingEnabled:
            answer.answer.question_automated_analysis_keyword_matching_enabled,
          questionAutomatedAnalysisWordsPerMinuteEnabled:
            answer.answer
              .question_automated_analysis_words_per_minute_enabled || false,
          questionAutomatedAnalysisFillerWordsEnabled:
            answer.answer.question_automated_analysis_filler_words_enabled ||
            false,
          questionAutomatedAnalysisConfidenceEnabled:
            answer.answer.question_automated_analysis_confidence_enabled ||
            false,
          id: answer.answer.id,
          questionId: answer.answer.question_id,
          currentUser: userName,
          gradable: answer.answer.gradable,
          question: answer.answer.question_text,
          questionType: answer.answer.question_type,
          correctAnswer: answer.answer.correct,
          feedback: answer.answer.feedback,
          givenAnswer: answer.answer.given_answer,
          givenAnswerIsIlos: answer.givenAnswerIsIlos,
          preview: true,
          isCurrentUser: currentUserId === progressUserId,
          currentUserId,
          criteriaRatings: answer.criteriaRatings,
          ratingOptions: ratings,
          mediaShareLink: answer.mediaShareLink,
          recording: answer.serializedRecording,
          skipReason: answer.skipReason,
          metadata: answer.answer.metadata || {},
        },
        meta: {
          skipped: answer.skipped,
          feedbackCriteriaPresent: answer.feedbackCriteriaPresent,
          apiKey: api,
          canViewSharableRecordingLink: canViewRecordingLink,
        },
        i18n: {
          questions: t('questions'),
          common: t('common'),
          progress: t('progress'),
          grades: t('grades'),
          no_description: t('feedback_criteria.criterion.no_description'),
        },
      };
      return (
        <>
          <div
            className={cn(
              'w-100p ta-l ReportCard-rowNumber ReportCard-rowNumber--counter',
              {
                'ReportCard-question': !answer.isChat,
                'ReportCard-chat': answer.isChat,
              },
            )}
          >
            <div className="d-f ai-c">
              {correctnessIconFragment(answer)}
              <span className="question-header-mobile">
                {answer.questionText}
                <div>
                  {answer.hasMetadata && !answer.emptyMetadata && (
                    <QuestionDetails
                      details={answer.details}
                      questionType={answer.questionType}
                    />
                  )}
                  {answer.isChat && !answer.emptyMetadata && (
                    <ChatDetails details={answer.details} />
                  )}
                  {answer.isDeleted && (
                    <small className="ReportCard-question--deleted">
                      {' '}
                      {t('questions.question.deleted')}{' '}
                    </small>
                  )}
                </div>
              </span>
            </div>
          </div>
          <div className={answer.givenAnswerClass}>
            {t('progress.report_card.given_answer')}:
            {answer.isMediaResponse && answer.isAnswerPresent && (
              <VideoResponse initialState={initialStateVideoResponse} />
            )}
            {answer.hasAnswerWithMetadata && (
              <div
                className={cn({
                  'c-success': answer.answer.correct,
                  'c-danger-red':
                    !answer.answer.correct && answer.answer.gradable,
                })}
              >
                {' '}
                <QuestionDetails details={answer.answer.given_answer} />{' '}
              </div>
            )}
            {!answer.hasAnswerWithMetadata && !answer.isMediaResponse && (
              <span className={`Answer ${answer.answerStatusClass}`}>
                <ConditionalList list={answer.givenAnswerList} />{' '}
              </span>
            )}
          </div>
          <div className={answer.correctAnswerClass}>
            <span className="correctAnswerTitle">
              {t('progress.report_card.correct_answer')}:
            </span>
            <ConditionalList list={answer.correctAnswerList} />{' '}
          </div>
          <div className="ReportCard-grader">
            {t('progress.report_card.graded_by')}
            <span className="pl-4">
              {answer.graderName || t('progress.report_card.no_grader')}
            </span>
          </div>

          {hasGraderFeedback && (
            <div className="ReportCard-feedback">
              {t('progress.report_card.feedback')}:
              {answer.feedbackCriteriaPresent && (
                <>
                  <CriteriaList data={data} />
                  <div className="fw-b">{t('grades.feedback.comments')}:</div>
                </>
              )}
              {answer.questionType === 'multiple_choice' && (
                <p>
                  <em>{t('grades.feedback.not_available')}</em>
                </p>
              )}
              {answer.answer.feedback && <div>{answer.answer.feedback}</div>}
              {!answer.answer.feedback &&
                answer.questionType !== 'multiple_choice' && (
                  <p>
                    <em>{t('grades.feedback.none_provided')}</em>
                  </p>
                )}
            </div>
          )}
        </>
      );
    });
  };
  return (
    <>
      <RenderMobileRows />
    </>
  );
};

export default ReportCardMobileView;
